import { useMemo } from 'react';

import { formatPrice } from '@/services/formatter';
import { checkIsValidJSON } from '@/services/helpers/checkIsValidJSON';

import type { TEurasV1BankOffer } from '../../../types/euras-v1.types';

interface IProps {
  bankOffer: TEurasV1BankOffer;
  offerDetailsModal: boolean | string;
}

const useAdditionalHelpers = ({ bankOffer, offerDetailsModal }: IProps) => {
  const eurasProducts = useMemo(() => {
    const approvedBody = JSON.parse(
      bankOffer.responseApprovedBody || '{}'
    )?.calculation;
    const description = JSON.parse(
      bankOffer.bankDescription || '{}'
    )?.calculation;
    if (!approvedBody && !description) return [];

    const items = [];
    let index = 1;

    while (
      approvedBody?.[`addName${index}`] !== undefined ||
      description?.[`addName${index}`] !== undefined
    ) {
      const props = approvedBody?.[`addName${index}`]
        ? approvedBody
        : description;
      const isHasSMS = (props?.[`addName${index}`] as string)?.match('SMS');

      const productObject = {
        addName: isHasSMS ? 'SMS' : (props?.[`addName${index}`] as string),
        addAmount: props?.[`addAmount${index}`] as number,
        addTerm: props?.[`addTerm${index}`] as string
      };
      if (productObject.addName) {
        items.push(
          `${productObject.addName}
              ${productObject.addAmount ? ` | ${formatPrice(productObject.addAmount)} ₸` : ''}
              ${productObject.addTerm ? ` | ${productObject.addTerm} м.` : ''}`.trim()
        );
      }
      index++;
    }

    return items;
  }, [bankOffer.responseApprovedBody, bankOffer.bankDescription]);

  const additionalProducts = useMemo(() => {
    const products = {
      title: 'Доп. продукты',
      content: [] as string[]
    };

    if (bankOffer.productInfo && typeof bankOffer.productInfo === 'object') {
      if (eurasProducts.length) {
        products.content.push(...eurasProducts);
      } else if (
        bankOffer.productInfo.current_value ||
        bankOffer.productInfo.product?.loan_period
      ) {
        products.content.push(
          `КАСКО ${
            bankOffer.productInfo.current_value
              ? JSON.parse(bankOffer.productInfo.current_value).loan_period
              : bankOffer.productInfo.product?.loan_period
                ? bankOffer.productInfo.product.loan_period
                : ''
          }`
        );
      }
    }

    return products;
  }, [bankOffer.productInfo, eurasProducts]);

  const getDescription = () => {
    const description = bankOffer.bankDescription || '';
    const isValidJSON = checkIsValidJSON(description);
    const parsedJSON =
      isValidJSON && JSON.stringify(JSON.parse(description), null, 2);

    return typeof offerDetailsModal === 'string'
      ? offerDetailsModal
      : parsedJSON || description;
  };

  return { additionalProducts, getDescription };
};

export default useAdditionalHelpers;
